var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._v(" Daily "),_c('bar-chart',{attrs:{"chart-data":_vm.dailyData,"height":170}}),_c('br'),_vm._v(" Accumulated "),_c('line-chart',{attrs:{"chart-data":_vm.accData,"height":170}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }